// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const bathhouse = defineModel({
  id: "bathhouse",
  batchId: "future",
  name: "Bathhouse",
  tags: ["building","bathhouse","low-poly","age-of-mcp","future"],
  summary: "A public bathhouse — hygiene, health and an amenity.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 1,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(1.7, 0.14, 1.7), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(1.7, 0.14, 1.7), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.4, 0.5, 1.4), color: "#c9c0b0", position: [0, 0.39, 0] },
      { geometry: new THREE.BoxGeometry(1.46, 0.1, 1.46), color: "#a89d84", position: [0, 0.19, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.5, 0.1), color: "#a89d84", position: [-0.7, 0.39, -0.7] },
      { geometry: new THREE.BoxGeometry(0.1, 0.5, 0.1), color: "#a89d84", position: [0.7, 0.39, -0.7] },
      { geometry: new THREE.BoxGeometry(0.1, 0.5, 0.1), color: "#a89d84", position: [-0.7, 0.39, 0.7] },
      { geometry: new THREE.BoxGeometry(0.1, 0.5, 0.1), color: "#a89d84", position: [0.7, 0.39, 0.7] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [-0.725, 0.5, -0.725] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [0.725, 0.5, -0.725] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [-0.725, 0.5, 0.725] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [0.725, 0.5, 0.725] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(1.7, 0.14, 1.7), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.4, 0.95, 1.4), color: "#c9c0b0", position: [0, 0.615, 0] },
      { geometry: new THREE.BoxGeometry(1.46, 0.1, 1.46), color: "#a89d84", position: [0, 0.19, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.95, 0.1), color: "#a89d84", position: [-0.7, 0.615, -0.7] },
      { geometry: new THREE.BoxGeometry(0.1, 0.95, 0.1), color: "#a89d84", position: [0.7, 0.615, -0.7] },
      { geometry: new THREE.BoxGeometry(0.1, 0.95, 0.1), color: "#a89d84", position: [-0.7, 0.615, 0.7] },
      { geometry: new THREE.BoxGeometry(0.1, 0.95, 0.1), color: "#a89d84", position: [0.7, 0.615, 0.7] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.5, 4), color: "#6b4a26", position: [-0.725, 0.75, -0.725] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.5, 4), color: "#6b4a26", position: [0.725, 0.75, -0.725] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.5, 4), color: "#6b4a26", position: [-0.725, 0.75, 0.725] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.5, 4), color: "#6b4a26", position: [0.725, 0.75, 0.725] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(1.7, 0.14, 1.7), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.4, 0.95, 1.4), color: "#c9c0b0", position: [0, 0.615, 0] },
      { geometry: new THREE.BoxGeometry(1.46, 0.1, 1.46), color: "#a89d84", position: [0, 0.19, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.95, 0.1), color: "#a89d84", position: [-0.7, 0.615, -0.7] },
      { geometry: new THREE.BoxGeometry(0.1, 0.95, 0.1), color: "#a89d84", position: [0.7, 0.615, -0.7] },
      { geometry: new THREE.BoxGeometry(0.1, 0.95, 0.1), color: "#a89d84", position: [-0.7, 0.615, 0.7] },
      { geometry: new THREE.BoxGeometry(0.1, 0.95, 0.1), color: "#a89d84", position: [0.7, 0.615, 0.7] },
      { geometry: new THREE.CylinderGeometry(0.62, 0.62, 0.08, 16), color: "#a89d84", position: [0, 1.13, 0] },
      { geometry: new THREE.SphereGeometry(0.66, 16, 9, 0, 6.283185, 0, 1.570796), color: "#b8c4c2", position: [0, 1.17, 0], scale: [1, 0.62, 1] },
      { geometry: new THREE.SphereGeometry(0.06, 8, 6), color: "#a89d84", position: [0, 1.59, 0] },
      { geometry: new THREE.BoxGeometry(0.34, 0.52, 0.05), color: "#3a4a4e", position: [0, 0.4, 0.71] },
      { geometry: new THREE.CylinderGeometry(0.17, 0.17, 0.05, 10, 1, false, 0, 3.141593), color: "#3a4a4e", position: [0, 0.66, 0.71], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.SphereGeometry(0.11, 7, 6), color: "#eef2f0", position: [0.22, 1.69, 0.1], scale: [1, 0.85, 1] },
      { geometry: new THREE.SphereGeometry(0.09, 7, 6), color: "#eef2f0", position: [0.34, 1.87, 0.04], scale: [1, 0.85, 1] },
      { geometry: new THREE.SphereGeometry(0.08, 7, 6), color: "#eef2f0", position: [-0.2, 1.75, -0.12], scale: [1, 0.85, 1] },
    ] },
  ],
  animations: [],
});
